<mat-card *ngIf="invitations$ | async as state">
  <mat-card-title>
    {{
      data.customerNumber
        ? ('GATEWAY.USER_INVITATION_LIST.TITLE' | translate)
        : ('GATEWAY.INVITATION_LIST.TITLE' | translate)
    }}
  </mat-card-title>

  <mat-card-content>
    <vi-loader *ngIf="!state.isData && state.loading" data-at-loader [isLoading]="true">
    </vi-loader>

    <ng-container *ngIf="state.loaded">
      <div class="header-row" [class.with-scrollbar]="state.invitationsIds.length > 4">
        <div class="header-row-inner flex flex-row justify-start items-center">
          <vi-dropdown
            data-at-event-type-filter
            class="flex-[18%] max-w-[18%]"
            [options]="statusFilters"
            [option]="initialFilter"
            width="80%"
            (optionChange)="onFilterChange($event)"
          >
          </vi-dropdown>
          <div class="header-row-item flex-[22%] max-w-[22%]">
            {{ 'GATEWAY.INVITATION_LIST.COLUMN.LAST_STATUS_CHANGE' | translate }}
          </div>
          <div class="header-row-item flex-[30%] max-w-[30%]">
            {{ 'GATEWAY.INVITATION_LIST.COLUMN.INVITER' | translate }}
          </div>
          <div class="header-row-item flex-[30%] max-w-[30%]">
            {{ 'GATEWAY.INVITATION_LIST.COLUMN.INVITEE' | translate }}
          </div>
        </div>
      </div>

      <ng-container *ngIf="state.isData && state.loaded">
        <app-infinite-scroll
          [state$]="invitations$"
          [search$]="searchType$"
          [itemSize]="itemSize"
          [limit]="limit"
          [(nextBatch)]="nextBatch"
          (nextBatchChange)="onNextBatchChange($event)"
          (fetchNext)="onFetchNext($event)"
        >
          <cdk-virtual-scroll-viewport [itemSize]="itemSize">
            <div *cdkVirtualFor="let token of state.invitationsIds" class="list-item">
              <app-invitation-list-item
                class="flex flex-row"
                [invitation]="state.invitations[token]"
                [inviter]="state.inviterDetails[state.invitations[token].inviterAccount]"
                [invitee]="state.inviteeDetails[state.invitations[token].inviteeAccount]"
                [inviteeCompany]="
                  state.inviteeCompanyDetails[state.invitations[token].customerNumber]
                "
                [inviterCompany]="
                  state.inviterCompanyDetails[state.invitations[token].inviterCustomerNumber]
                "
              ></app-invitation-list-item>
            </div>
            <vi-loader
              *ngIf="nextBatch"
              [isLoading]="true"
              message="{{ 'GATEWAY.INVITATION_LIST.LOADING_MORE' | translate }}"
            ></vi-loader>
          </cdk-virtual-scroll-viewport>
        </app-infinite-scroll>
      </ng-container>

      <ng-container *ngIf="!state.isData && state.loaded">
        <div class="no-results">{{ 'GATEWAY.INVITATION_LIST.NO_RESULTS' | translate }}</div>
      </ng-container>
    </ng-container>
  </mat-card-content>

  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center">
    <button
      id="cancel-btn"
      mat-button
      gtm="onClose"
      gtmCategory="Gateway invitation list"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
